import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  menuButton: {
    height: 64,
    width: 64
  },
  appBar: {
    top: 0,
    maxHeight: 107,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#fefefe'
  },
  offset: theme.mixins.toolbar,
  offset1: {
    minHeight: 64
  },
  divider: {
    width: '100%'
  },
  hide: {
    display: "none !important"
  },
  saveButton:{
    backgroundColor: '#B22222',
    width: '300px',
    height: '40px',
    marginTop: '40px',
    '&:hover':{
      backgroundColor: '#B22222'
    }
  },
  title: {
    fontSize: '1.5rem',
    marginTop: '24px',
    marginBottom: '10px',
    fontWeight: 500,
    alignSelf: 'flex-start'
  },
}));
